<div class="container">
  <app-checkbox [checked]="true" (checkedChange)="score($event)"
    >Include score</app-checkbox
  >
  <app-checkbox [checked]="true" (checkedChange)="label($event)"
    >Include labels</app-checkbox
  >
  <app-color-select (selectChange)="color($event)"></app-color-select>
  <div class="threshold">
    Threshold %
    <app-input
      type="number"
      [value]="80"
      (valueChange)="threshold($event)"
    ></app-input>
  </div>
</div>
